// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Formless_Data_FormFieldResult = require("../Formless.Data.FormFieldResult/index.js");
var U = (function () {
    function U() {

    };
    U.value = new U();
    return U;
})();
var OutputField = function (x) {
    return x;
};
var InputFunction = function (x) {
    return x;
};
var InputField = function (x) {
    return x;
};
var FormProxy = (function () {
    function FormProxy() {

    };
    FormProxy.value = new FormProxy();
    return FormProxy;
})();
var FormField = function (x) {
    return x;
};
var newtypeOutputField = new Data_Newtype.Newtype(function (n) {
    return n;
}, OutputField);
var newtypeInputFunction = new Data_Newtype.Newtype(function (n) {
    return n;
}, InputFunction);
var newtypeInputField = new Data_Newtype.Newtype(function (n) {
    return n;
}, InputField);
var newtypeFormField = new Data_Newtype.Newtype(function (n) {
    return n;
}, FormField);
var eqOutputField = function (dictEq) {
    return dictEq;
};
var eqInputField = function (dictEq) {
    return dictEq;
};
var eqFormField = function (dictEq) {
    return function (dictEq1) {
        return function (dictEq2) {
            return new Data_Eq.Eq(function (x) {
                return function (y) {
                    return Data_Eq.eq(dictEq1)(x.input)(y.input) && Data_Eq.eq(Formless_Data_FormFieldResult.eqFormFieldResult(dictEq)(dictEq2))(x.result)(y.result) && x.touched === y.touched;
                };
            });
        };
    };
};
module.exports = {
    FormProxy: FormProxy,
    InputField: InputField,
    OutputField: OutputField,
    U: U,
    InputFunction: InputFunction,
    FormField: FormField,
    newtypeInputField: newtypeInputField,
    eqInputField: eqInputField,
    newtypeOutputField: newtypeOutputField,
    eqOutputField: eqOutputField,
    newtypeInputFunction: newtypeInputFunction,
    newtypeFormField: newtypeFormField,
    eqFormField: eqFormField
};
